import { Component, OnInit, HostListener } from '@angular/core';
import { UserService } from '../../../services/user.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

    dealID: number;
    userName: string = '';
    myInnerHeight: number;

    constructor(private usersService: UserService) {
        
    }

    ngOnInit() {
        this.userName = this.isUserLoggedIn() ? this.usersService.getCurrentUser().userName : '';
        //console.log(window.innerHeight);
        this.myInnerHeight = window.innerHeight;
    }

    isUserLoggedIn() {
        return this.usersService.isUserLoggedIn();
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        //console.log(window.innerHeight);
        this.myInnerHeight = window.innerHeight;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/home-page/home/home.component.ts